<template>
  <b-modal
    id="change-password-modal"
    centered
    title="Change Password"
    @hide="resetData"
    ref="change_password_modal"
  >
    To ensure maximum security, when you change your password you are logged
    out.
    <b-form @submit="submit" @input="formInput" class="mt-4">
      <b-form-group
        :invalid-feedback="formErrors.oldpassword"
        :state="fieldState.oldpassword"
        label="Old Password"
      >
        <b-form-input
          id="oldpassword"
          v-model="form.oldpassword"
          type="password"
          :state="fieldState.oldpassword"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :invalid-feedback="formErrors.newpassword"
        :state="fieldState.newpassword"
        label="New Password"
      >
        <b-form-input
          id="newpassword"
          v-model="form.newpassword"
          type="password"
          :state="fieldState.newpassword"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :invalid-feedback="formErrors.newpasswordconfirm"
        :state="fieldState.newpasswordconfirm"
        label="Confirm New Password"
      >
        <b-form-input
          id="newpasswordconfirm"
          v-model="form.newpasswordconfirm"
          type="password"
          :state="fieldState.newpasswordconfirm"
          required
        ></b-form-input>
      </b-form-group>
    </b-form>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="light" @click="cancel()">Cancel</b-button>
      <StatefulButton
        :error="error"
        :loading="submitting"
        loadingText="Saving..."
        text="Save"
        variant="primary"
        @click="submit"
      />
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import StatefulButton from "@/components/actions/StatefulButton";

import { AuthService } from "@/services";
import {
  validateRequired,
  checkFormErrors,
  validatePassword
} from "@/utils/validators";

export default {
  name: "change-password",
  data() {
    return {
      form: {
        oldpassword: "",
        newpassword: "",
        newpasswordconfirm: ""
      },
      formErrors: {},
      error: false,
      submitting: false
    };
  },
  components: {
    StatefulButton
  },
  computed: {
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        await AuthService.changePassword(this.form);
        this.$store.dispatch("toast", {
          message:
            "Your password has been changed successfully. Please login in again"
        });
        this.$refs.change_password_modal.hide();
        const self = this;
        setTimeout(() => {
          self.logout();
        }, 1000);
      } catch (err) {
        this.formErrors = err;
        this.error = true;
        this.submitting = false;
      }
    },
    validateForm() {
      const { oldpassword, newpassword, newpasswordconfirm } = this.form;
      let { errors, valid } = validateRequired({ oldpassword, newpassword });
      if (!errors.newpassword) {
        const res = validatePassword(newpassword);
        errors.newpassword = res.errors.password;
        valid = valid && res.valid;
      }
      if (!errors.newpassword && newpassword !== newpasswordconfirm) {
        errors.newpasswordconfirm = "Passwords must match";
        valid = false;
      }
      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
};
</script>

<style lang="scss" scoped></style>
